export default {
  title: 'Zmień nazwę oferty',
  subtitle: 'Wprowadź nową nazwę oferty (maksymalnie 40 znaków)',
  toasts: {
    success: 'Pomyślnie zmieniono nazwę oferty',
    error: 'Nie udało się zmienić nazwy oferty',
  },
  buttons: {
    rename: 'Zmień nazwę',
  },
  form: {
    title: {
      label: 'Nazwa oferty',
      placeholder: 'Wpisz nazwę oferty',
    },
  },
};
